import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { getBalance, readContracts, simulateContract, switchChain, waitForTransactionReceipt, writeContract } from '@wagmi/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { encodeFunctionData, formatEther, formatUnits } from 'viem';
import { environment } from "../../environments/environment";
import { BestwalletComponent } from "../modals/bestwallet/bestwallet.component";
import { ClaimComponent } from "../modals/claim/claim.component";
import { SwapStatus, getParam, getParamWithoutCookie } from '../shared/constants/app-enums';
import { config } from "./config";
import { PopupService } from './popup.service';
import { WalletConnectService } from './wallet-connect.service';


/**
 * variable used for the presale smart contract
 * of different network
 */


const staking = require('../../assets/contracts/staking.json');
const token = require('../../assets/contracts/token.json');

const presaleEth = require('../../assets/contracts/presaleETH.json');


/**
 * here the presale ABI and Address are set
 * for read, write and prepair contract
 */
const stakeContract = {
  address: environment.stakingAddress as any,
  abi: staking.abi,
} as const

const tokenContract = {
  address: environment.tokenAddress as any,
  abi: token.abi,
} as const

const presaleContractEth = {
  address: environment.eth.presaleAddress as any,
  abi: presaleEth.abi,
} as const

@Injectable({
  providedIn: 'root'
})

export class ClaimService {
  swapStatus = SwapStatus.not_started;
  walletAddress: string = '';
  oldWalletAddress: string = '';
  referUrl: string = '';
  client: any;
  wagmiData: any;
  chainId: any;
  mode: any;
  presaleData: any;
  swapHash: any = '';
  refreshId: any;
  refreshRate: number = 5000;

  /* variables used for Wallet connection */

  metaMaskConnector: any;
  walletConnector: any;
  walletConnectorBW: any;
  uriConnector: any;

  /* predefined values of the essential variables */

  balanceData: {
    nativeBal: number,
    usdtBal: number,
    ethTokenSold: number,
    bscTokenSold: number,
    // polyTokenSold: number,
    totalTokensSold: number,
    ethClaimable?: number,
    // polyClaimable?: number,
    bscClaimable?: number,
    userClaimable: number,
    currentStep: number,
    startTime?: any,
    endTime?: any,
    paused?: boolean,
    usdRaised: number,
    maxTokensToBuy?: number,
    oneEth: number,
    oneBnb: number,
    // onePoly: number,
    ethUsdt: number,
    bnbUsdt: number,
    // polyUsdt: number
  } = {
      nativeBal: 0,
      usdtBal: 0,
      ethTokenSold: 0,
      bscTokenSold: 0,
      totalTokensSold: 0,
      ethClaimable: 0,
      bscClaimable: 0,
      userClaimable: 0,
      // polyTokenSold: 0,
      // polyClaimable: 0,
      startTime: '',
      endTime: '',
      paused: false,
      currentStep: 0,
      usdRaised: 0,
      maxTokensToBuy: 0,
      oneEth: 0,
      oneBnb: 0,
      ethUsdt: 0,
      bnbUsdt: 0,
      // polyUsdt: 0,
      // onePoly: 0
    }

  stakeData: {
    planId: number;
    userStaked: number,
    userStakedV2: number,
    totalStaked: number,
    rewardPerRound: number,
    userPoolPercent: number,
    apy: number,
    apyV2: number,
    unlockTime: number,
    unlockTimeV2: number,
    userReward: number,
    userRewardV2: number,
    userBal: number,
    isClaimEnabled: boolean;
    stackPercent: number;
    rewardsPA: number;
    rewardsPaid: number;
  } = {
      userStaked: 0,
      userStakedV2: 0,
      totalStaked: 0,
      rewardPerRound: 0,
      userPoolPercent: 0,
      apy: 0,
      apyV2: 0,
      unlockTime: 0,
      unlockTimeV2: 0,
      userReward: 0,
      userRewardV2: 0,
      userBal: 0,
      isClaimEnabled: false,
      planId: 0,
      stackPercent: 0,
      rewardsPA: 0,
      rewardsPaid: 0,
    }

  config: any;
  modalRef?: BsModalRef;
  isClaimLive: boolean = true;
  currentDate: number = Date.parse(new Date().toString());

  constructor(
    private http: HttpClient,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService
  ) {
    /**
     * wagmi createConfig setup for auto connect feature
     * and available connectors of wagmi.
     */

  }



  async getClaimsItem(walletAddress:string) {
    if (this.wagmiData?.isConnected) this.getMetaData(); // if user is connected then call this function    
    const address = walletAddress || "0x0000000000000000000000000000000000000000";
    
    const smartContract = {
      contracts: [

        // =========== ETH Contract ==============
        {
          ...presaleContractEth,
          functionName: 'userDeposits', // this method is returning the total token purchased by current user via ETH network.
          chainId: environment.eth.chainIdInt, // 0
          args: [address]
        },


        // =========== Staking Contract ==============
        {
          ...stakeContract,
          functionName: 'poolStakers',
          chainId: environment.eth.chainIdInt, // 1
          args: [address]
        },
        {
          ...stakeContract,
          functionName: 'getRewards',
          chainId: environment.eth.chainIdInt, // 2
          args: [address]
        },
        {
          ...stakeContract,
          functionName: 'rewardTokensPerBlock',
          chainId: environment.eth.chainIdInt, // 3
          args: []
        },
        {
          ...stakeContract,
          functionName: 'tokensStaked',
          chainId: environment.eth.chainIdInt, // 4
          args: []
        },
        {
          ...stakeContract,
          functionName: 'harvestLock',
          chainId: environment.eth.chainIdInt, // 5
          args: []
        },
        {
          ...tokenContract,
          functionName: 'balanceOf',
          chainId: environment.eth.chainIdInt, // 6
          args: [address]
        },
      ]
    } as const

    if (this.walletConnectService.walletAddress) {
      if (this.mode) {
        localStorage.setItem("connectionMode", this.mode)
      } else {
        this.mode = localStorage.getItem("connectionMode");
      }
    }

    /**
     * Above contracts are going to be read.
     */

    this.presaleData = await readContracts(config, smartContract);

    console.log('\n******presaleData =', this.presaleData, '\n******\n');

    this.stakeData.userStaked = +formatEther(this.presaleData[1].result[0] || 0);
    this.stakeData.unlockTime = +formatEther(this.presaleData[1].result[3] || 0);
    this.stakeData.planId = Number(this.presaleData[1].result[4]);
    this.stakeData.userReward = +formatEther(this.presaleData[2]?.result || 0);
    this.stakeData.rewardPerRound = +formatEther(this.presaleData[3].result || 0);
    this.stakeData.totalStaked = +formatEther(this.presaleData[4].result || 0);
    this.stakeData.isClaimEnabled = !this.presaleData[5].result || false;
    this.stakeData.apy = +((+this.stakeData.rewardPerRound * 2629743 / this.stakeData.totalStaked) * 100).toFixed(0);
    this.stakeData.userBal = +formatEther(this.presaleData[6].result || 0)


    /* assigning the value of no of token sold va bsc and eth contract */


    this.balanceData.ethClaimable = +formatEther(this.presaleData[0].result || 0);
    this.balanceData.userClaimable = this.balanceData.ethClaimable;


    console.log('\n******presaleData =', this.presaleData, this.stakeData, '\n******\n');

    // console.log('tokenBuyLimit', tokenBuyLimit, this.tokenomics[this.balanceData.currentStep].maxToken, this.soldToken, this.balanceData.maxTokensToBuy )

    console.log('\n******\n RPC balanceData =', this.balanceData, this.stakeData, '\n******\n');
    // console.log('\n******\n RPC tokenomicsData =', this.tokenomics, '\n******\n');


    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getClaimsItem(walletAddress), this.refreshRate); // Call the self method on each 5secs interval


  }


  /**
   * This method is used to fetch the native balance
   * of the current account and network
   */

  async getMetaData() {

    const nativeBalance = await getBalance(config, {
      address: this.walletConnectService.walletAddress as any,
    })
    console.log({ nativeBalance }, "==== native balance");


    // const usdtBal = await getBalance(config, {
    //   address: this.walletAddress as any,
    //   token: this.getChainData().usdTAddress as any,
    // })

    /* user's Eth/Bnb and USDT balance */
    this.balanceData.nativeBal = +formatUnits(nativeBalance.value, nativeBalance.decimals);
    // this.balanceData.usdtBal = +formatUnits(usdtBal.value, usdtBal.decimals);


    // if(this.referUrl === '') this.refer();
  }

  /**
   * returning no of total sold tokens
   */
  get soldToken() {
    return this.balanceData.totalTokensSold;
  }


  isEthChain(): boolean {
    return this.walletConnectService.chainId === environment.eth.chainIdInt ? true : false;
  }

  // isBscChain(): boolean {
  //   return this.chainId === environment.bsc.chainIdInt ? true : false;
  // }

  /**
   * switching the current network. If user is on wrong network
   * and got error on switching then a popup
   * will appear saying to connect correct chain
   */


  async claim(amount: number) {
    console.log('Claim called');
    const { request } = await simulateContract(config, {
      ...presaleContractEth,
      functionName: 'claim',
      chainId: environment.eth.chainIdInt,
      args: [],
      account: this.walletConnectService.walletAddress as any // Optional param. Not required!
    })

    await writeContract(config, request)
      .then(async (hash: any) => {
        this.sendClaimBwData(amount, "claim", hash);
        this.swapStatus = SwapStatus.in_progess;                      // setting swapStatus to inprogress mode
        console.log('Claim success', hash);
        this.modalRef?.hide();
        this.modalRef = this.modalService.show(ClaimComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
          initialState: { isClaim: true }
        });
        await waitForTransactionReceipt(config, { hash: hash as any })
          .then((response: any) => {
            this.swapStatus = SwapStatus.complete;    // setting swapStatus to completed
            console.log('claim response', response);
            this.modalRef?.hide();
            this.modalRef = this.modalService.show(ClaimComponent, {
              class: 'modal-xs modal-dialog-centered',
              backdrop: 'static',
              initialState: { isClaim: true }
            });
          },
            (err: any) => {
              this.swapStatus = SwapStatus.failed; // setting swapStatus to failed
            });
      },
        (err: any) => {
          console.log('Claim error', err);
          this.swapStatus = SwapStatus.rejected;
        });
  }


  async claimStake(amount: number) {
    console.log('claimStake called');
    this.swapStatus = SwapStatus.in_progess
    const { request } = await simulateContract(config, {
      ...presaleContractEth,
      functionName: 'claimAndStake',
      chainId: environment.eth.chainIdInt,
      args: [],
      account: this.walletConnectService.walletAddress as any // Optional param. Not required!
    })
    await writeContract(config, request)
      .then(async (hash: any) => {
        console.log('claimStake success', hash);
        this.sendClaimBwData(amount, "claimandstake", hash);
        this.swapHash = hash; // assigning succes transaction hash id
        this.swapStatus = SwapStatus.in_progess;                      // setting swapStatus to inprogress mode
        await waitForTransactionReceipt(config, { hash: hash as any })
          .then((response: any) => {
            console.log('checkTansaction success', response);
            this.getMetaData(); // update the current native balance
            this.swapStatus = SwapStatus.complete;    // setting swapStatus to completed
          },
            (err: any) => {
              console.log('checkTansaction error', err);
              this.getMetaData(); // update the current native balance
              this.swapStatus = SwapStatus.failed; // setting swapStatus to failed
            });
      },
        (err: any) => {
          console.log('claimStake error', err);
          this.swapStatus = SwapStatus.failed
        });
  }



  /**
   * Function to claim and stake the token
   */

  async claimStakeRewards() {
    console.log('claimStakeRewards called');
    const { request } = await simulateContract(config, {
      ...stakeContract,
      functionName: 'harvestRewards',
      chainId: environment.eth.chainIdInt,
      args: [],
      account: this.walletConnectService.walletAddress as any // Optional param. Not required!
    })
    await writeContract(config, request)
      .then((hash: any) => {
        this.swapStatus = SwapStatus.complete;    // setting swapStatus to completed
        console.log('claimStakeRewards success', hash);
      },
        (err: any) => {
          this.swapStatus = SwapStatus.failed;    // setting swapStatus to completed
          console.log('claimStakeRewards error', err);
        });
  }



  /**
 * generate signature for wert transaction
 * @param amount Amount to spend
 * @returns signature data
 */
  async getABI(amount: number, isStake: boolean = false): Promise<string> {
    const data = encodeFunctionData({
      abi: presaleEth.abi,
      functionName: 'buyWithETHWert',
      args: [this.walletConnectService.walletAddress, amount, isStake]
    })
    return data;
  }

  /**
* Function to buy app token via wert widget.
* this function convert the USDT value to app token
* @param amount: Amount to spend
* @returns : converted no of app tokens
*/

  getDynamicAmountWert = async (amount: number) => {
    console.log('getDynamicAmountWert', amount)
    const contractData = await readContracts(config, {
      contracts: [
        {
          ...presaleContractEth,
          functionName: 'ethBuyHelper',
          chainId: environment.eth.chainIdInt,
          args: [amount]
        }
      ]
    });
    let ehtVal = +formatEther(contractData[0].result as any);
    console.log('return DynamicAmountWert', ehtVal)
    return +ehtVal;
  }


  sendClaimBwData = (amount: number, event: string, hash: string) => {
    if (environment.production) {
      const tokens: any = (this.balanceData.ethClaimable || 0);
      const lastRoundTokenPrice = 0.01 // this needs to be value of last round usdt price
      const data = {
        publicAddress: this.walletConnectService.walletAddress,
        event: event,
        tokenSymbol: "PEPU",
        tokenContractAddress: environment.tokenAddress,
        purchaseTokens: amount,
        purchaseTypeAmount: +amount,
        purchaseUsdAmount: +(amount * lastRoundTokenPrice),
        ipAddress: '',
        clickId: getParam('clickId'),
        source: getParam('source'),
        hash: hash,
        chainId: this.chainId,
        purchaseType: event,
        presaleName: "Pepe Unchained",
        isBW: true,
        rABsZdfEqoXvExie: getParamWithoutCookie('rABsZdfEqoXvExie') || undefined,
      }
      console.log("Tokens claimable", amount)
      console.log('BW data =', tokens, data)
      this.http.post(environment.bwApiUrl, data).subscribe((res: any) => {
        console.log('BW success response', res);
      },
        (err: any) => {
          console.log('BW error response', err);
        });
    }
  }

  getChainData() {
    switch (this.walletConnectService.chainId) {
      case environment.eth.chainIdInt:
        return environment.eth;
      // case environment.bsc.chainIdInt:
      //   return environment.bsc;
      // case environment.poly.chainIdInt:
      //   return environment.poly;
      default:
        return environment.eth;
    }
  }

  getPresaleContract() {
    switch (this.walletConnectService.chainId) {
      case environment.eth.chainIdInt:
        return presaleContractEth;
      // case environment.bsc.chainIdInt:
      //   return presaleContractBsc;
      // case environment.poly.chainIdInt:
      //   return presaleContractPoly;
      default:
        return presaleContractEth;
    }
  }



  bestWalletModal(): void {
    const addClass = (this.mode == "walletBW" || this.mode == "bw") ? 'modal-sm modal-dialog-centered bw-modal-isBw' : 'modal-lg modal-dialog-centered bw-modal';
    this.modalRef = this.modalService.show(BestwalletComponent, {
      class: addClass,
      backdrop: 'static',
      initialState: { isBw: (this.mode == "walletBW" || this.mode == "bw") ? true : false }
    });
  }

}


